export default "__VITE_ASSET__C$h9ldCR__"